module.exports = __webpack_public_path__ + "img/Porto Apartment - 73 of 85.06986751.jpeg";